module.exports = __webpack_public_path__ + "static/media/lina.b2dbd9fb.jpg";